if (!window.Eurus.loadedScript.has('size-dropdown.js')) {
  window.Eurus.loadedScript.add('size-dropdown.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      // Custom ul/li dropdown that mirrors a native <select>, keeping the
      // select itself as the single source of truth so existing variant
      // logic (bound to the select's own "change" event) keeps working
      // untouched.
      Alpine.data('xSizeDropdown', () => ({
        open: false,
        options: [],
        label: '',
        init() {
          this.refresh();
        },
        // The variant-selects-main wrapper survives every AJAX-driven variant
        // re-render (only its innerHTML gets replaced), so a flag stored on
        // it is the one thing that reliably remembers "the shopper has
        // actually chosen a size" across those re-renders.
        _picker() {
          return this.$el.closest('.variant-selects-main');
        },
        _hasChosen() {
          return this._picker()?.dataset.sizeChosen === 'true';
        },
        refresh() {
          const select = this.$refs.nativeSelect;
          if (!select) return;
          this.options = Array.from(select.options).map((option, index) => ({
            index,
            value: option.value,
            text: option.textContent.trim(),
            disabled: option.disabled,
            selected: option.selected,
          }));
          if (!this._hasChosen()) {
            // Cosmetic only, and only until the shopper picks a size
            // themselves: show the placeholder even though the underlying
            // <select> already carries a real value (e.g. from the theme's
            // "default select available variant" setting). We never touch
            // select.value here, so variant/price/media sync stays intact.
            const placeholder = this.options.find((option) => option.value === '');
            this.label = placeholder ? placeholder.text : '';
            return;
          }
          const selectedOption = this.options.find((option) => option.selected);
          this.label = selectedOption ? selectedOption.text : '';
        },
        toggle() {
          if (this.open) {
            this.close();
          } else {
            this.refresh();
            this.open = true;
          }
        },
        close() {
          this.open = false;
        },
        choose(opt) {
          if (opt.disabled) return;
          const select = this.$refs.nativeSelect;
          select.value = opt.value;
          const picker = this._picker();
          if (picker) picker.dataset.sizeChosen = 'true';
          // Dispatch a real "change" event so every existing listener
          // already bound to this select (variant selection, price,
          // media, etc.) fires exactly as if the user had used the
          // native control.
          select.dispatchEvent(new Event('change', { bubbles: true }));
          this.refresh();
          this.close();
          this.$refs.trigger?.focus();
        },
      }));
    });
  });
}
